import {
	collection, doc,
	getDoc,
	onSnapshot, orderBy, query, limitToLast,
	where
} from "firebase/firestore";

import { signInToBroadcastService } from "_services/firebase";

import { firestoreConfig } from "..";

const db  = firestoreConfig.broadcast;
const col = "broadcast-sessions";

const convertToString = broadcastId => {
	return String ( broadcastId );
};

export const getTopDonor = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref     = doc ( db, col, convertToString ( broadcastId ) );
	const chatRef = collection ( ref, "pinnedChat" );
	const _query  = query ( chatRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getMutedUsersList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref           = doc ( db, col, convertToString ( broadcastId ) );
	const mutedUsersRef = collection ( ref, "bannedUsers" );
	const _query        = query ( mutedUsersRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getBlockedUsersList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref             = doc ( db, col, convertToString ( broadcastId ) );
	const blockedUsersRef = collection ( ref, "blockedUsers" );
	const _query          = query ( blockedUsersRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getDonationsList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref          = doc ( db, col, convertToString ( broadcastId ) );
	const donationsRef = collection ( ref, "donations" );
	const _query       = query ( donationsRef, orderBy ( "createdAt" ) );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	}, error => {
		callback ( null, error );
	} );
};

export const getBroadcastComments = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const currentTS = Math.floor ( new Date ().getTime () / 1000 ); // createdAt is in seconds

	const ref    = doc ( db, col, convertToString ( broadcastId ) );
	const comRef = collection ( ref, "comments" );
	const _query = query ( comRef, orderBy ( "createdAt", "desc" ), where ( "createdAt", ">", currentTS ) );
	// const _query = query ( comRef, orderBy ( "createdAt", "desc" ), limit ( 250 ) );

	let isInitial = true;

	return onSnapshot ( _query, snapshot => {
		if ( isInitial ) {
			isInitial = false;

			return;
		}

		callback ( snapshot );
	}, error => {
		callback ( null, error );
	} );
};

export const getSessionListener = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref    = doc ( db, col, convertToString ( broadcastId ) );
	const newRef = collection ( ref, "updatedSessionData" );
	const _query = query ( newRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getPinnedComments = async ( broadcastId, commentId ) => {
	await signInToBroadcastService ();

	const ref    = doc ( db, col, convertToString ( broadcastId ) );
	const comRef = collection ( ref, "comments" );
	const docRef = doc ( comRef, commentId );
	const res    = await getDoc ( docRef );

	return res.data ();
};

export const getReactionsListener = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref          = doc ( db, col, convertToString ( broadcastId ) );
	const reactionsRef = collection ( ref, "updatedSessionData/data/reactions" );
	const _query       = query ( reactionsRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getChatTips = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref     = doc ( db, col, convertToString ( broadcastId ) );
	const chatRef = collection ( ref, "chatTips" );
	const _query  = query (
		chatRef,
		orderBy ( "id", "desc" ),
		limitToLast ( 1 )
		/* where("chatTip/ctaText", "==", "AFFL_AD"), */
		/* orderBy("id", "desc"), */
		/* limit(1) */
	);

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};